import { useAppContext } from 'hooks/context/useAppContext';

export const useWebsite = () => {
  const { publicUser } = useAppContext();
  const {
    about,
    cover_image_original: coverImageOriginal,
    slug,
    preferences: {
      portfolio_visible: showPortfolio,
      show_team_on_website: showTeam,
    },
  } = publicUser ?? {};

  return {
    home: {
      hero: {
        image: coverImageOriginal,
      },
    },
    about: {
      aboutText: about,
    },
    slug: slug,
    showPortfolio,
    showTeam,
  };
};
